// Cross-flow list
export const FETCH_MATERIO_LIST = 'FETCH_MATERIO_LIST';
export const FETCH_MATERIO_LIST_SUCCESS = 'FETCH_MATERIO_LIST_SUCCESS';
export const FETCH_MATERIO_LIST_FAIL = 'FETCH_MATERIO_LIST_FAIL';

// DESCENDING — single
export const FETCH_DESC = 'FETCH_DESC';
export const FETCH_DESC_SUCCESS = 'FETCH_DESC_SUCCESS';
export const FETCH_DESC_FAIL = 'FETCH_DESC_FAIL';

export const CREATE_DESC = 'CREATE_DESC';
export const CREATE_DESC_SUCCESS = 'CREATE_DESC_SUCCESS';
export const CREATE_DESC_FAIL = 'CREATE_DESC_FAIL';

export const UPDATE_DESC = 'UPDATE_DESC';
export const UPDATE_DESC_SUCCESS = 'UPDATE_DESC_SUCCESS';
export const UPDATE_DESC_FAIL = 'UPDATE_DESC_FAIL';

export const DELETE_DESC = 'DELETE_DESC';
export const DELETE_DESC_SUCCESS = 'DELETE_DESC_SUCCESS';
export const DELETE_DESC_FAIL = 'DELETE_DESC_FAIL';

export const CHANGE_STATUS_DESC = 'CHANGE_STATUS_DESC';
export const CHANGE_STATUS_DESC_SUCCESS = 'CHANGE_STATUS_DESC_SUCCESS';
export const CHANGE_STATUS_DESC_FAIL = 'CHANGE_STATUS_DESC_FAIL';

export const ADD_DESC_ATTACHMENT = 'ADD_DESC_ATTACHMENT';
export const ADD_DESC_ATTACHMENT_SUCCESS = 'ADD_DESC_ATTACHMENT_SUCCESS';
export const ADD_DESC_ATTACHMENT_FAIL = 'ADD_DESC_ATTACHMENT_FAIL';

export const REMOVE_DESC_ATTACHMENT = 'REMOVE_DESC_ATTACHMENT';
export const REMOVE_DESC_ATTACHMENT_SUCCESS = 'REMOVE_DESC_ATTACHMENT_SUCCESS';
export const REMOVE_DESC_ATTACHMENT_FAIL = 'REMOVE_DESC_ATTACHMENT_FAIL';

// ASCENDING — single
export const FETCH_ASC = 'FETCH_ASC';
export const FETCH_ASC_SUCCESS = 'FETCH_ASC_SUCCESS';
export const FETCH_ASC_FAIL = 'FETCH_ASC_FAIL';

export const CREATE_ASC = 'CREATE_ASC';
export const CREATE_ASC_SUCCESS = 'CREATE_ASC_SUCCESS';
export const CREATE_ASC_FAIL = 'CREATE_ASC_FAIL';

export const UPDATE_ASC = 'UPDATE_ASC';
export const UPDATE_ASC_SUCCESS = 'UPDATE_ASC_SUCCESS';
export const UPDATE_ASC_FAIL = 'UPDATE_ASC_FAIL';

export const DELETE_ASC = 'DELETE_ASC';
export const DELETE_ASC_SUCCESS = 'DELETE_ASC_SUCCESS';
export const DELETE_ASC_FAIL = 'DELETE_ASC_FAIL';

export const CHANGE_STATUS_ASC = 'CHANGE_STATUS_ASC';
export const CHANGE_STATUS_ASC_SUCCESS = 'CHANGE_STATUS_ASC_SUCCESS';
export const CHANGE_STATUS_ASC_FAIL = 'CHANGE_STATUS_ASC_FAIL';

// Activity feed (shared)
export const FETCH_MATERIO_ACTIVITY = 'FETCH_MATERIO_ACTIVITY';
export const FETCH_MATERIO_ACTIVITY_SUCCESS = 'FETCH_MATERIO_ACTIVITY_SUCCESS';
export const FETCH_MATERIO_ACTIVITY_FAIL = 'FETCH_MATERIO_ACTIVITY_FAIL';

// Clear messages
export const CLEAR_MATERIO_MESSAGES = 'CLEAR_MATERIO_MESSAGES';
